export const FETCH_VIDEOS_SUCCESS = "FETCH_VIDEOS_SUCCESS";
export const FETCH_VIDEOS_REQUEST = "FETCH_VIDEOS_REQUEST";
// Action to fetch videos
export const fetchVideos = (id) => async (dispatch) => {
  dispatch({ type: FETCH_VIDEOS_REQUEST });
  try {
    const response = await fetch(
      `https://dev-admin.hqz.app/client/video/getVideoAndUser?videoId=${id}`,
      { headers: { key: "aw6xayDawf3cUm22QtMHlxfL8lZESl0W" } }
    ); // Replace with your API endpoint
    const data = await response.json();

    dispatch({
      type: FETCH_VIDEOS_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    console.log(error.message);
  }
};
